// layouts/DashboardLayout.jsx
import { Outlet } from 'react-router-dom';
import decoration from "../../assets/images/decorationPiece.png";
import Sidebar from "../../components/Company/Sidebar";
import Navbar from "../../components/Company/Navbar";
import Footer from "../../components/Company/Footer";
import { UserProvider } from '../../context/UserContext';
import { useTranslation } from 'react-i18next';

const DashboardLayout = () => {
      const { t, i18n } = useTranslation();
      const isRTL = i18n.language === 'ar';
const decorationStyles = {
  position: "fixed",
  top: 0,
  height: "100vh",
  background: "transparent",
  ...(isRTL 
    ? { 
        left: 0,
        transform: "scaleX(-1)"
      } 
    : { 
        right: 0 
      }
  )
};

  return (
    <UserProvider>
    <div
        className="inter-font layout-wrapper inter-font"
        style={{
          // width: "100%",
          // minHeight: "100vh",
          // display: "flex",
          // // flexDirection: "row",
          // // flexWrap: "wrap",
          // // height: "100vh",

          display: "flex",
          height: "100vh", // 💡 Full screen height
          width: "100%",
          overflow: "hidden",
        }}
      >
        {/* Sidebar */}
        <div
          style={{
            // flexBasis: "25%",
            // flexGrow: 1,
            // maxWidth: "300px",
            // minWidth: "250px",
            // width: "100%",
            // minHeight: "100%",
            display: "flex",
            flexDirection: "row",

            // height: "100vh", // 💡 full height
          overflowY: "auto", // optional: scroll sidebar if it overflows
          flexShrink: 0, // prevents shrinking
          }}
        >
          <Sidebar />
        </div>

        {/* Content + Decoration Row */}
        <div
          style={{
            flexBasis: "75%",
            flexGrow: 1,
            width: "100%",
            display: "flex",
            flexDirection: "row",
            // padding: "20px",
            overflowY: "auto",
            background:
              "linear-gradient(to left, rgba(255, 245, 241, 1), rgba(241, 239, 235, 1))",
          }}
        >
          {/* Main Content Area */}
          <div
            style={{
              // flex: 1,
              // display: "flex",
              // flexDirection: "column",
              // minHeight: "100vh",

              flex: 1,
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              overflow: "hidden",
            }}
            className="inter-font pt-3"
          >
            <Navbar />
            <div style={{   flex: 1,
          overflowY: "auto",
          padding: "20px",
          position: "relative"  }} className="inter-font px-4 md:px-5">
              <Outlet />
            </div>
            <Footer />
          </div>

          {/* Decoration Image (Right Side) */}
          <div
            className="inter-font d-none d-lg-flex"
          >
            <img
              src={decoration}
              alt="Decoration"
              style={decorationStyles}
            />
          </div>
        </div>
      </div>
</UserProvider>
  );
};

export default DashboardLayout;